import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrNishaKapoorContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Nisha Kapoor"
      specialization="Senior Medical Advisor & Mentor"
      experience="30+ Years"
      degrees="MBBS, MD, FRCOG (London) from Premier Institutions"
      quote="I believe I am becoming a pregnancy crafter by helping build a more human model of maternal care."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "With over three decades of practice, my focus has shifted from treating individual patients to fixing a broken system. My philosophy is that care must be holistic, continuous, and deeply human. A mother's mental and emotional state is as critical as her physical parameters. We must use technology not to create distance, but to enable deeper, more consistent human connection.",
        },
        {
          title: "Why I Chose Myprega",
          body: "I didn't just choose Myprega; I chose to help build it. This is the manifestation of everything I believe is missing in traditional healthcare. It's a system designed from the ground up for the mother's peace of mind. By mentoring our doctors in the Myprega way, I am helping to create a new generation of medical experts who are not just clinicians, but true partners in care.",
        },
        {
          title: "Beyond the Clinic",
          body: "I am passionate about mentoring young doctors and often give guest lectures at medical colleges. I unwind by playing the sitar, which I've been learning for the last five years. It's a humbling lesson in discipline and beauty. My library is filled with books on leadership and systems thinking.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "The Fifth Discipline by Peter Senge" },
        { icon: "🎵", label: "Favourite Musician", value: "Ravi Shankar" },
        { icon: "🎼", label: "Favourite Pastime", value: "Playing the sitar\nMentoring and guest lecturing" },
      ]}
    />
  );
};

export default DrNishaKapoorContent;
